export default {
    routerName: '岗位管理',
    post: {
        searchName: '检索条件',
        name: '岗位名',
        code: '岗位号',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    table: {
        id: 'ID',
        name: '岗位',
        code: '岗位号',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
    },
};
